exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-table-tbody .ant-table-row td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n#components-layout-demo-custom-trigger .trigger {\n  font-size: 18px;\n  line-height: 64px;\n  padding: 0 24px;\n  cursor: pointer;\n  -webkit-transition: color 0.3s;\n  transition: color 0.3s;\n}\n.table-page-search-wrapper .ant-form-inline .ant-form-item {\n  margin-bottom: 12px;\n  margin-right: 0;\n}\n", ""]);

// exports
